interface SafeStorage {
  getItem: (key: string) => string | null;
  removeItem: (key: string) => void;
  setItem: (key: string, value: string) => void;
}

type StorageName = "localStorage" | "sessionStorage";

const createSafeStorage = (storageName: StorageName): SafeStorage => {
  const fallback = new Map<string, string>();
  let isBrowserStorageAvailable = true;

  return {
    getItem: key => {
      if (isBrowserStorageAvailable) {
        try {
          const value = window[storageName].getItem(key);
          if (value === null) {
            fallback.delete(key);
          } else {
            fallback.set(key, value);
          }
          return value;
        } catch {
          isBrowserStorageAvailable = false;
        }
      }

      return fallback.get(key) ?? null;
    },
    setItem: (key, value) => {
      if (isBrowserStorageAvailable) {
        try {
          window[storageName].setItem(key, value);
          fallback.set(key, value);
          return;
        } catch {
          isBrowserStorageAvailable = false;
        }
      }

      fallback.set(key, value);
    },
    removeItem: key => {
      if (isBrowserStorageAvailable) {
        try {
          window[storageName].removeItem(key);
          fallback.delete(key);
          return;
        } catch {
          isBrowserStorageAvailable = false;
        }
      }

      fallback.delete(key);
    },
  };
};

export const browserLocalStorage = createSafeStorage("localStorage");
export const browserSessionStorage = createSafeStorage("sessionStorage");
